import ExecutaRest from '../util/ExecutaRest'


class grupoTratamentoUFClassificacaoApi {

    static ObterGrupoTratamentoUFClassificacaoPorGrupoUF(parametros) {
        var rest = new ExecutaRest();

        return new Promise(function (resolve, reject) {
            rest.Post('GrupoTratamentoUFClassificacaoSL.svc/Rest/ObterGrupoTratamentoUFClassificacaoPorGrupoUFREST', parametros).then(retorno => {
                
                if (retorno.dado) {
                    
                    resolve(Object.assign({}, retorno));
                } else if (retorno.erro || (retorno.dado === null && retorno.erro === null)) {
                    
                    reject(retorno.erro);
                }
            }).catch(error => {
                
                reject('Ocorreu um erro inesperado em --> ObterMensagemPorProtocoloSenha: ' + error /*areaTratamento.statusText*/);
            });

        });
    }



}

export default grupoTratamentoUFClassificacaoApi;


/** WEBPACK FOOTER **
 ** ./src/components/api/grupoTratamentoUFClassificacaoApi.js
 **/